(function () {
  'use strict';

  /* ===== Drawer controller ===== */
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const focusable = el.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer[aria-hidden="false"]')) {
      document.body.classList.remove('drawer-open');
    }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer[aria-hidden="false"]').forEach(closeDrawer);
      document.querySelectorAll('.customize-modal[aria-hidden="false"]').forEach((m) => {
        const closer = m.querySelector('.customize-modal__close');
        if (closer) closer.click();
      });
    }
  });

  /* ===== Cart-drawer toggle from header ===== */
  document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => {
      if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer') {
        e.preventDefault();
        openDrawer('cart-drawer');
      }
    });
  });

  function customizeModalEn(form) {
    return form && form.getAttribute('data-customize-modal') === 'true';
  }

  /* ===== Cart fetch helpers ===== */
  async function fetchCart() {
    const res = await fetch(window.theme.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  async function refreshCartDrawer() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    // Subtotal text
    document.querySelectorAll('[data-cart-subtotal]').forEach((el) => {
      el.textContent = formatMoney(cart.total_price);
    });
    // For full re-render, fetch /cart page and replace the cart-drawer aside (snippet rendered there too)
    try {
      const res = await fetch(window.theme.routes.cart_url, { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.querySelector('#cart-drawer .drawer__panel');
      const current = document.querySelector('#cart-drawer .drawer__panel');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (e) { /* silent */ }
  }

  function formatMoney(cents) {
    const fmt = window.theme.moneyFormat || '${{amount}}';
    const amt = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, amt);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ===== Product form: add to cart with FormData (preserves file uploads) ===== */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart]');
    const originalText = btn ? btn.textContent : '';
    const en = customizeModalEn(form);
    if (btn) { btn.disabled = true; btn.textContent = en ? 'Adding...' : window.theme.strings.adding; }
    try {
      const fd = new FormData(form);
      const res = await fetch(window.theme.routes.cart_add_url + '.js', { method: 'POST', body: fd });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Add to cart failed');
      }
      if (btn) btn.textContent = en ? 'Added!' : window.theme.strings.added;
      const customizeModal = form.querySelector('.customize-modal[aria-hidden="false"]');
      if (customizeModal) {
        customizeModal.querySelector('.customize-modal__close')?.click();
      }
      await refreshCartDrawer();
      if (window.theme.settings.cartType === 'drawer') {
        openDrawer('cart-drawer');
      } else {
        window.location.href = window.theme.routes.cart_url;
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setTimeout(() => {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      }, 1200);
    }
  });

  /* ===== Variant picker ===== */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-variants]');
      try { this.variants = JSON.parse(dataEl.textContent); } catch { this.variants = []; }
      this.addEventListener('change', () => this.onChange());
    }
    onChange() {
      const selected = {};
      this.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        const m = input.name.match(/options\[(.+)\]/);
        if (m) selected[m[1]] = input.value;
      });
      this.querySelectorAll('[data-selected-value]').forEach((el) => {
        const k = el.getAttribute('data-selected-value');
        if (selected[k]) el.textContent = selected[k];
      });
      const match = this.variants.find((v) => {
        return Object.keys(selected).every((k, i) => v.options[i] === selected[k]);
      });
      if (!match) return;

      // update featured image via gallery slide
      const mediaId = match.featured_media ? match.featured_media.id : null;
      if (mediaId) {
        const slides = document.querySelectorAll('.product-gallery__slide');
        slides.forEach((slide) => {
          if (slide.getAttribute('data-media-id') == mediaId) {
            slide.classList.add('is-active');
            slide.setAttribute('aria-hidden', 'false');
            slide.style.display = '';
          } else {
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          }
        });
        // sync thumbnail active state
        const thumbs = document.querySelectorAll('[data-gallery-thumb]');
        thumbs.forEach((t) => {
          const active = t.getAttribute('data-media-id') == mediaId;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      const form = this.closest('form');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
        const btn = form.querySelector('[data-add-to-cart]');
        if (btn) {
          btn.disabled = !match.available;
          const en = customizeModalEn(form);
          btn.textContent = match.available
            ? (en ? 'Add to cart' : window.theme.strings.addToCart)
            : (en ? 'Sold out' : window.theme.strings.soldOut);
        }
        const customizeOpen = form.querySelector('[data-open-customize-modal]');
        if (customizeOpen) {
          customizeOpen.disabled = !match.available;
        }
      }
      // update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      // notify price node
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: match } }));
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* ===== Product gallery: thumbs ===== */
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      const id = thumb.getAttribute('data-media-id');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => {
        t.classList.toggle('is-active', t === thumb);
        t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
      });
      gallery.querySelectorAll('.product-gallery__slide').forEach((slide) => {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
        slide.setAttribute('aria-hidden', slide.getAttribute('data-media-id') === id ? 'false' : 'true');
      });
    });
  });

  /* ===== File upload preview ===== */
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-file-upload]');
    if (!input || !input.files || !input.files[0]) return;
    const file = input.files[0];
    const wrap = input.closest('.field--file-upload');
    const preview = (wrap && wrap.querySelector('[data-file-preview]')) || input.parentElement.querySelector('[data-file-preview]');
    if (!preview) return;
    const formRoot = input.closest('form[data-customize-modal]');
    const en = customizeModalEn(formRoot);
    const errType = en ? 'Only JPG, PNG or WEBP images are allowed.' : window.theme.strings.uploadError;
    const errSize = en ? 'Image must be smaller than 10MB.' : window.theme.strings.uploadSize;
    preview.innerHTML = '';
    if (!file.type.startsWith('image/')) {
      preview.innerHTML = '<span class="field__error">' + errType + '</span>';
      input.value = '';
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      preview.innerHTML = '<span class="field__error">' + errSize + '</span>';
      input.value = '';
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = document.createElement('img');
      img.src = ev.target.result;
      const lbl = wrap && wrap.querySelector('.field__label');
      const altFromLabel = lbl ? lbl.textContent.replace(/\s*\*\s*$/, '').trim() : '';
      img.alt = altFromLabel || file.name;
      preview.appendChild(img);
    };
    reader.readAsDataURL(file);
  });

  /* ===== Quantity buttons ===== */
  document.addEventListener('click', (e) => {
    const incBtn = e.target.closest('[data-qty-increase]');
    const decBtn = e.target.closest('[data-qty-decrease]');
    if (!incBtn && !decBtn) return;
    const wrap = (incBtn || decBtn).parentElement;
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    let v = parseInt(input.value, 10) || 0;
    v = incBtn ? v + 1 : Math.max(parseInt(input.min || 0, 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ===== Cart line item qty/remove ===== */
  let cartUpdateTimer = null;
  document.addEventListener('change', (e) => {
    const qty = e.target.closest('[data-cart-qty]');
    if (!qty) return;
    const key = qty.getAttribute('data-key');
    const val = parseInt(qty.value, 10);
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(() => updateCartLine(key, val), 250);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    updateCartLine(rm.getAttribute('data-key'), 0);
  });

  async function updateCartLine(key, quantity) {
    try {
      const res = await fetch(window.theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('Cart update failed');
      await refreshCartDrawer();
      // If on /cart, refresh items area
      const mainCart = document.querySelector('[data-cart-main]');
      if (mainCart) {
        const fresh = await fetch(window.theme.routes.cart_url);
        const html = await fresh.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const replacement = tmp.querySelector('[data-cart-main]');
        if (replacement) mainCart.innerHTML = replacement.innerHTML;
      }
    } catch (err) {
      console.error(err);
    }
  }

  /* ===== Product customize modal ===== */
  document.querySelectorAll('[data-product-form][data-customize-modal]').forEach((form) => {
    const modal = form.querySelector('.customize-modal');
    if (!modal) return;
    const openBtn = form.querySelector('[data-open-customize-modal]');
    const hasStep2 = form.getAttribute('data-customize-has-step2') === 'true';
    const totalSteps = parseInt(form.getAttribute('data-customize-total-steps'), 10) || 2;
    const reviewStep = totalSteps;
    const stepPanels = modal.querySelectorAll('[data-customize-step-panel]');
    const nextBtn = modal.querySelector('[data-customize-next]');
    const backBtn = modal.querySelector('[data-customize-back]');
    const qtyRow = modal.querySelector('[data-customize-qty-row]');
    const submitBtn = modal.querySelector('[data-add-to-cart]');
    const progressSegs = modal.querySelectorAll('.customize-modal__progress-seg');
    const triggerMyComputer = modal.querySelector('[data-trigger-primary-file]');
    const titleEl = modal.querySelector('.customize-modal__title');
    const guideBlocks = modal.querySelectorAll('.customize-modal__guide-img, .customize-modal__tips, .photo-guide');

    let currentStep = 1;

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function updateTitle(step) {
      if (!titleEl) return;
      if (step === 1) {
        titleEl.textContent = form.dataset.customizeTitleStep1 || '';
      } else if (step === 2 && hasStep2) {
        titleEl.textContent = form.dataset.customizeTitleStep2 || '';
      } else {
        titleEl.textContent = form.dataset.customizeTitleStep3 || '';
      }
    }

    function setProgress(displayStep) {
      progressSegs.forEach((seg, i) => {
        seg.classList.toggle('is-active', i < displayStep);
      });
      if (progressSegs.length === 1) {
        progressSegs[0].classList.add('is-active');
      }
    }

    function populateReview() {
      const host = modal.querySelector('[data-customize-review]');
      if (!host) return;
      const RV = 'Variant';
      const RP = 'Your photos';
      const RO = 'Customization';
      const RQ = 'Quantity';
      const sections = [];

      const vp = form.querySelector('variant-picker');
      if (vp) {
        let rows = '';
        vp.querySelectorAll('.variant-option').forEach((opt) => {
          const labEl = opt.querySelector('.variant-option__label');
          if (!labEl) return;
          const clone = labEl.cloneNode(true);
          clone.querySelectorAll('[data-selected-value]').forEach((x) => x.remove());
          const dt = clone.textContent.replace(/:\s*$/, '').trim();
          const dd = opt.querySelector('[data-selected-value]')?.textContent?.trim();
          if (dt && dd) {
            rows += '<div class="customize-review__row"><span class="customize-review__dt">' + escapeHtml(dt) + '</span> <span class="customize-review__dd">' + escapeHtml(dd) + '</span></div>';
          }
        });
        if (rows) {
          sections.push('<section class="customize-review__section"><h3 class="customize-review__h">' + escapeHtml(RV) + '</h3>' + rows + '</section>');
        }
      }

      const photoCells = [];
      modal.querySelectorAll('.field--file-upload').forEach((field) => {
        const label = field.querySelector('.field__label')?.textContent?.replace(/\s*\*\s*$/, '').trim();
        const img = field.querySelector('[data-file-preview] img');
        if (img && img.src) {
          const safeSrc = String(img.src).replace(/"/g, '&quot;');
          photoCells.push(
            '<div class="customize-review__photo"><div class="customize-review__phlabel">' + escapeHtml(label || '') + '</div><img src="' + safeSrc + '" alt=""></div>'
          );
        }
      });
      if (photoCells.length) {
        sections.push(
          '<section class="customize-review__section"><h3 class="customize-review__h">' + escapeHtml(RP) + '</h3><div class="customize-review__photos">' + photoCells.join('') + '</div></section>'
        );
      }

      const optionsPanel = modal.querySelector('[data-customize-step-panel="2"]');
      let optRows = '';
      if (optionsPanel) {
        optionsPanel.querySelectorAll('select, input[type="text"], textarea').forEach((el) => {
          if (!el.name || el.name.indexOf('properties[') !== 0) return;
          const lab = el.id ? form.querySelector(`label[for="${el.id}"]`) : null;
          let labelText = lab ? lab.textContent.replace(/\s*\*\s*$/, '').trim() : el.name;
          let val = '';
          if (el.tagName === 'SELECT') {
            val = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : '';
          } else {
            val = el.value || '';
          }
          if (val) {
            optRows += '<div class="customize-review__row"><span class="customize-review__dt">' + escapeHtml(labelText) + '</span> <span class="customize-review__dd">' + escapeHtml(val) + '</span></div>';
          }
        });
      }
      if (optRows) {
        sections.push('<section class="customize-review__section"><h3 class="customize-review__h">' + escapeHtml(RO) + '</h3>' + optRows + '</section>');
      }

      const qtyInput = modal.querySelector('[data-customize-qty-row] input[type="number"]');
      const qtyVal = qtyInput ? qtyInput.value : '1';
      sections.push(
        '<section class="customize-review__section customize-review__section--qty"><h3 class="customize-review__h">' + escapeHtml(RQ) + '</h3><p class="customize-review__qty-val">' + escapeHtml(qtyVal) + '</p></section>'
      );

      host.innerHTML = sections.join('');
    }

    function showStep(step) {
      currentStep = step;
      stepPanels.forEach((panel) => {
        const n = parseInt(panel.getAttribute('data-customize-step-panel'), 10);
        panel.hidden = n !== step;
      });
      guideBlocks.forEach((el) => {
        el.hidden = step !== 1;
      });
      updateTitle(step);
      setProgress(step);

      const onReview = step === reviewStep;
      if (nextBtn) {
        nextBtn.hidden = onReview;
        nextBtn.style.display = onReview ? 'none' : '';
      }
      if (backBtn) backBtn.hidden = step === 1;
      if (qtyRow) qtyRow.hidden = !onReview;
      if (submitBtn) submitBtn.hidden = !onReview;

      if (onReview) populateReview();
    }

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('customize-modal-open');
      showStep(1);
      setTimeout(() => {
        const focusTarget = modal.querySelector('[data-trigger-primary-file]');
        if (focusTarget) focusTarget.focus();
      }, 100);
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('customize-modal-open');
      showStep(1);
    }

    if (openBtn) {
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    }
    modal.querySelectorAll('[data-close-customize-modal]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    if (triggerMyComputer) {
      triggerMyComputer.addEventListener('click', () => {
        const primary = modal.querySelector('[data-primary-file-input]');
        const any = modal.querySelector('[data-file-upload]');
        (primary || any)?.click();
      });
    }

    function validateStep1Files() {
      const step1 = modal.querySelector('[data-customize-step-panel="1"]');
      if (!step1) return true;
      const requiredFiles = step1.querySelectorAll('input[type="file"][required]');
      for (let i = 0; i < requiredFiles.length; i++) {
        const inp = requiredFiles[i];
        if (!inp.files || !inp.files.length) {
          inp.focus();
          alert('Please upload the required photo before continuing.');
          return false;
        }
      }
      return true;
    }

    function validateStep2Options() {
      const panel = modal.querySelector('[data-customize-step-panel="2"]');
      if (!panel) return true;
      const controls = panel.querySelectorAll('input, select, textarea');
      for (let i = 0; i < controls.length; i++) {
        const el = controls[i];
        if (typeof el.reportValidity === 'function' && !el.reportValidity()) {
          return false;
        }
      }
      return true;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentStep === 1) {
          if (!validateStep1Files()) return;
          if (hasStep2) {
            showStep(2);
          } else {
            showStep(reviewStep);
          }
          return;
        }
        if (currentStep === 2 && hasStep2) {
          if (!validateStep2Options()) return;
          showStep(reviewStep);
        }
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentStep === reviewStep) {
          showStep(hasStep2 ? 2 : 1);
        } else if (currentStep === 2 && hasStep2) {
          showStep(1);
        }
      });
    }

    const qtyInputEl = modal.querySelector('[data-customize-qty-row] input[type="number"]');
    if (qtyInputEl) {
      qtyInputEl.addEventListener('change', () => {
        if (currentStep === reviewStep) populateReview();
      });
    }

    (function setupExtraFileTriggers() {
      const step1 = modal.querySelector('[data-customize-step-panel="1"]');
      if (!step1) return;
      const fields = Array.from(step1.querySelectorAll('.field--file-upload'));
      fields.forEach((wrap, idx) => {
        if (idx === 0) return;
        if (wrap.querySelector('[data-extra-file-trigger]')) return;
        const inp = wrap.querySelector('input[type="file"]');
        if (!inp) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'customize-modal__source-btn customize-modal__source-btn--secondary';
        btn.setAttribute('data-extra-file-trigger', 'true');
        btn.textContent = 'Add optional image';
        btn.addEventListener('click', () => inp.click());
        const label = wrap.querySelector('.field__label');
        if (label) {
          label.insertAdjacentElement('afterend', btn);
        } else {
          wrap.insertBefore(btn, wrap.firstChild);
        }
      });
    })();

    showStep(1);
  });

  /* ===== Predictive search ===== */
  const searchInput = document.querySelector('[data-predictive-search]');
  if (searchInput) {
    const resultsBox = document.querySelector('[data-predictive-results]');
    let timer;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      if (q.length < 2) {
        if (resultsBox) { resultsBox.hidden = true; resultsBox.innerHTML = ''; }
        return;
      }
      timer = setTimeout(async () => {
        try {
          const url = window.theme.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
          const res = await fetch(url);
          const html = await res.text();
          if (resultsBox) {
            resultsBox.innerHTML = html;
            resultsBox.hidden = false;
          }
        } catch { /* silent */ }
      }, 250);
    });
  }
})();
